<app-expansion-panel [titre]="'Ressource professionnelle ' + (idx() + 1)" [item]="form()" [isOpen]="true">
  <form class="p-lg gap-md grid" [formGroup]="form()">
    <div hlmField>
      <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom de la ressource professionnelle</label>
      <hlm-autocomplete
        [(search)]="search"
        [id]="'nom-' + idx"
        [filteredOptions]="toutesLesRessources()"
        [optionTemplate]="option"
        [autocompleteSearchClass]="isFormInvalid() ? 'border-danger border' : 'border-grey-3 border'"
        (searchChange)="onSearchChange($event)"
        formControlName="ressource"
      >
        <ng-template #option let-option>{{ option.nom }}</ng-template>
      </hlm-autocomplete>
      @if (isFormInvalid()) {
        <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
      }
    </div>

    <div hlmField>
      <label hlmFieldLabel for="select-type">Type</label>
      <hlm-select class="inline-block" placeholder="Sélectionnez un type" formControlName="type">
        <hlm-select-trigger id="select-type">
          <hlm-select-value>
            <div class="flex items-center gap-x-2" *brnSelectValue="let value">
              <ng-icon [name]="getIcon(value)" hlm size="sm" />
              {{ value }}
            </div>
          </hlm-select-value>
        </hlm-select-trigger>
        <hlm-select-content>
          @for (option of ressourcesTypes; track option.label) {
            <hlm-option [value]="option.label">
              <ng-icon class="mr-2" [name]="option.icon" hlm size="sm" />
              {{ option.label }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>

    <div hlmField>
      <label hlmFieldLabel for="select-productions">Rattacher aux productions</label>
      <hlm-select
        class="inline-block"
        placeholder="Sélectionnez une ou plusieurs productions"
        formControlName="idsProductions"
        multiple
      >
        <hlm-select-trigger id="select-productions">
          <hlm-select-value />
        </hlm-select-trigger>
        <hlm-select-content>
          @for (production of productions(); track production.id) {
            <hlm-option [value]="production.id">
              {{ production.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </form>
</app-expansion-panel>
